module.exports = __webpack_public_path__ + "components/flag/static/square/cr-6885c70c497982f8cbd15031c57effdd.svg";